import { render, staticRenderFns } from "./MobileServicePromotion.vue?vue&type=template&id=245a0ec9&"
import script from "./MobileServicePromotion.vue?vue&type=script&lang=js&"
export * from "./MobileServicePromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('245a0ec9')) {
      api.createRecord('245a0ec9', component.options)
    } else {
      api.reload('245a0ec9', component.options)
    }
    module.hot.accept("./MobileServicePromotion.vue?vue&type=template&id=245a0ec9&", function () {
      api.rerender('245a0ec9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "auth_ui/static/vue-src/components/ServicePromotion/MobileServicePromotion.vue"
export default component.exports